import { Box, Drawer, Icon } from '@mui/material';
import { LencoTypography } from '@/atomic-components/LencoTypography';
import { useMemo } from 'react';
import CareProgramVas from '@/assets/vas/CareProgramVas.svg';
import FlexiCancellation from '@/assets/vas/FlexiCancellation.svg';
import FlexBox from '@/atomic-components/FlexBox';
import { getColor } from '@/utils/theme/colors';
import { getStyle } from '@/utils/theme/fonts';
import { TCartValueAddedServices } from '@/services/cart/models/cart';
import StarsBg from '../CartVasCard/StarsBg';

const vasTypeStyleMapping = {
	FURLENCO_CARE_PROGRAM: {
		background: 'linear-gradient(0deg, #B4E1E5 0%, #CEEDF0 100%)',
	},
	FLEXI_CANCELLATION: {
		background: 'linear-gradient(180deg, #FEEAD2 0%, #FDCFA6 100%)',
	},
};

const vasTypeStarStyleMapping = {
	FURLENCO_CARE_PROGRAM: {
		background: getColor('Minty -5'),
	},
	FLEXI_CANCELLATION: {
		background: getColor('Orange -5'),
	},
};

const vasTypeIconMap = {
	FURLENCO_CARE_PROGRAM: <CareProgramVas />,
	FLEXI_CANCELLATION: <FlexiCancellation />,
	// FLEX_CANCELLATION: <RentToOwn />,
	// FLEX_CANCELLATION: <AssuredSellBack />,
};

const cartTypeCartNameMap = {
	RENTAL: 'Rent',
};

interface IVasDescriptionCardProps {
	vas: TCartValueAddedServices;
}

const VasDescriptionCard = (props: IVasDescriptionCardProps) => {
	const background = vasTypeStyleMapping[props.vas?.type]?.background;
	const icon = vasTypeIconMap[props.vas?.type];
	const starColor = vasTypeStarStyleMapping[props.vas?.type];

	return (
		<FlexBox width='100%' sx={{ background, borderRadius: '16px' }}>
			<Box sx={{ position: 'absolute', zIndex: 2 }}>
				<StarsBg color={starColor.background} />
			</Box>
			<FlexBox
				sx={{ p: '24px' }}
				direction='row'
				justifyContent='space-between'
				width='100%'
			>
				<Box sx={{ textAlign: 'left', ml: '8px', width: '100%' }}>
					<FlexBox direction='row' justifyContent='flex-start'>
						{icon}
						<Box ml='8px'>
							<LencoTypography
								sx={{
									...getStyle('H9_Medium'),
									color: getColor('Gray 0'),
								}}
							>
								{props.vas?.title}
							</LencoTypography>
							<LencoTypography
								sx={{
									...getStyle('Small_Regular'),
									color: getColor('Gray -1'),
								}}
							>
								{props.vas?.subtitle}
							</LencoTypography>
							<LencoTypography
								sx={{
									textOverflow: 'wrap',
									...getStyle('Small_Regular'),
									color: getColor('Gray -1'),
								}}
							>
								{props.vas?.description}
							</LencoTypography>
						</Box>
					</FlexBox>
				</Box>
			</FlexBox>
		</FlexBox>
	);
};

export default VasDescriptionCard;
